.title {
    font-size: 24px;
    font-weight: 700;
    color: #303030;
}